import React from 'react';
import PropTypes from 'prop-types';

import { StyledDiv } from './CollectionDropdownBtnStyles';

var CollectionDropdownBtn = function CollectionDropdownBtn(props) {
  return React.createElement(
    StyledDiv,
    {
      onMouseOver: props.handleDropdownBtnEnter,
      onFocus: props.handleDropdownBtnEnter,
      btnDisabled: props.btnDisabled,
      dropdownActive: props.dropdownActive
    },
    props.showDropdownOption ? props.selectedOptions[props.option.name] : props.option.name
  );
};

CollectionDropdownBtn.propTypes = {
  handleDropdownBtnEnter: PropTypes.func.isRequired,
  selectedOptions: PropTypes.object.isRequired,
  option: PropTypes.object.isRequired,
  showDropdownOption: PropTypes.bool.isRequired,
  btnDisabled: PropTypes.bool,
  dropdownActive: PropTypes.bool
};

export default CollectionDropdownBtn;